import { Box, Grid, Typography, useTheme } from "@mui/material";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import {
	EnhancedDialog,
	EnhancedDropDownRHFWithLabel,
	IDNDList,
	IEnhancedDropDownItem,
	LabelPosition,
} from "@websential/cosmic-v20";
import { FC, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useNavigateToLogout } from "../../../common/Common";

interface ICompanyStatutoryHolidayInfoSetupFieldsPanel {
	// countryList: any;
	provinceDDLItems: (value: any) => void;
	onDisableCardsOptions: (value: boolean) => void;
	handleOpenEligibilityPanelDragable: () => void;
	statutoryHolidayFormDataByClientId: any
	onSnackbarMessageData?: (value: any) => void;
}
export const CompanyStatutoryHolidayInfoSetupFieldsPanel: FC<
	ICompanyStatutoryHolidayInfoSetupFieldsPanel
> = ({
	// // countryList,
	// provinceDDLItems,
	onDisableCardsOptions,
	handleOpenEligibilityPanelDragable,
	statutoryHolidayFormDataByClientId,
	onSnackbarMessageData,
}) => {
		const theme = useTheme();
		const [provinceDDL, setprovinceDDL] = useState([]);
		const navigateToLogout = useNavigateToLogout();

		const [disableOption, setDisableOption] = useState(undefined);
		const onDisableChangeOptions = (event: any) => {
			setDisableOption(event.value);
			onDisableCardsOptions(event.value === 100 ? false : true);
			if (onSnackbarMessageData && event.value === 100) {
				onSnackbarMessageData({
					open: true,
					severity: "error",
					message: "Changing Holiday Pay setting for the company will erase holiday pay amount calculated for the current open pay period for all employees."
				})
			}
		};

		useEffect(() => {
			if (statutoryHolidayFormDataByClientId && statutoryHolidayFormDataByClientId.calculateStatutoryHoliday) {
				setDisableOption(statutoryHolidayFormDataByClientId.calculateStatutoryHoliday);
				onDisableCardsOptions(statutoryHolidayFormDataByClientId.calculateStatutoryHoliday === 100 ? false : true);
			}
		}, [statutoryHolidayFormDataByClientId]);

		const optionsDisable = disableOption === 200;

		return (
			<Box>
				<EnhancedDropDownRHFWithLabel
					selectName="calculateStatutoryHoliday"
					label="Calculate Statutory Holiday"
					labelPosition={LabelPosition.Top}
					// required
					testId={`calculate-company-statutory-holiday`}
					items={[
						{ label: "Yes", value: 200 },
						{ label: "No", value: 100 },
					]}
					selectedItem={100}
					onSelectionChangeHandler={onDisableChangeOptions}
					labelColumns={4}
					fieldColumns={8}
				/>

				<Grid
					container
					sx={{
						display: "flex",
						mb: "2.1rem",
					}}
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				>
					<Grid
						size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
						sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem" }}
					>
						Employee Eligibility
					</Grid>

					<Grid
						size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
						sx={{ textAlign: "right", fontSize: ".875rem" }}
					>
						<Link
							to="#"
							className="no-underline"
							style={{ color: theme.palette.primary.light }}
							onClick={handleOpenEligibilityPanelDragable}
						>
							Click Here
						</Link>
					</Grid>
				</Grid>

				<EnhancedDropDownRHFWithLabel
					selectName="accruePayout"
					label="Accrue / Pay out"
					labelPosition={LabelPosition.Top}
					// required
					testId={`Accrue-Pay-out`}
					items={[
						{ label: "Accrue", value: 100 },
						{ label: "Pay out", value: 200 },
					]}
					selectedItem={100}
					labelColumns={4}
					fieldColumns={8}
					isDisabled={!optionsDisable}
				/>
				<EnhancedDropDownRHFWithLabel
					selectName="displayStatutoryHoliday"
					label="Display Statutory Holiday"
					labelPosition={LabelPosition.Top}
					// required
					testId={`Display-Statutory-Holiday`}
					items={[
						{ label: "When it Occurs", value: 200 },
						{ label: "At all Times", value: 100 },
					]}
					selectedItem={200}
					labelColumns={4}
					fieldColumns={8}
					isDisabled={!optionsDisable}
				/>
			</Box>
		);
	};
